import { render, staticRenderFns } from "./ModalNewTask.vue?vue&type=template&id=0393caf5&scoped=true"
import script from "./ModalNewTask.vue?vue&type=script&lang=js"
export * from "./ModalNewTask.vue?vue&type=script&lang=js"
import style0 from "./ModalNewTask.vue?vue&type=style&index=0&id=0393caf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0393caf5",
  null
  
)

export default component.exports